import { useQuery } from "@tanstack/react-query";

import { LastOpenedClientResponse, clientsApi } from "@/api";
import { QueryKey } from "@/query/Query";

export function useClientList() {
  const { data, isLoading } = useQuery<LastOpenedClientResponse[] | null | undefined>({
    queryKey: [QueryKey.LastOpenedClients],
    queryFn: () => clientsApi.getLastOpenedClients(),
  });

  return {
    clients: data ?? [],
    isLoading,
  };
}
